import {
  Facebook,
  Instagram,
  Pinterest,
  Snapchat,
  Tiktok,
  Twitter,
  Youtube,
} from '@components/icons'
import { FC } from 'react'

interface Props {
  item: any
}

const ns = `site-footer`

enum SocialIcons {
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  TWITTER = 'Twitter',
  YOUTUBE = 'Youtube',
  SNAPCHAT = 'Snapchat',
  PINTEREST = 'Pinterest',
  TIKTOK = 'TikTok',
}

const SocialIcon: FC<Props> = ({ item }) => {
  let iconEl = null
  switch (item.linkIcon) {
    case SocialIcons.FACEBOOK:
      iconEl = <Facebook />
      break
    case SocialIcons.INSTAGRAM:
      iconEl = <Instagram />
      break
    case SocialIcons.TWITTER:
      iconEl = <Twitter />
      break
    case SocialIcons.YOUTUBE:
      iconEl = <Youtube />
      break
    case SocialIcons.SNAPCHAT:
      iconEl = <Snapchat />
      break
    case SocialIcons.PINTEREST:
      iconEl = <Pinterest />
      break
    case SocialIcons.TIKTOK:
      iconEl = <Tiktok />
      break
    default:
      break
  }

  return (
    <div className={`${ns}__social-icon__item`}>
      <a
        href={item.isExternal ? `https://www.${item.target}` : item.target}
        target="_blank"
        rel="noreferrer"
      >
        {iconEl}
      </a>
    </div>
  )
}

export default SocialIcon
